
export const APP_ROUTES = {
  AUTH: 'auth',
  MAIN: 'main',
  HOME: 'home',
  SIGN_UP: 'sign-up',
  CREATE_PASSWORD: 'create-password',
  COMPLETE_REGISTRATION: 'complete-registration',
  VERIFY: 'verify',
  VERIFY_EMAIL: 'verify-email',
  FORGOT_PASSWORD: 'forgot-password',
  MY_WAY: 'my-way',
  MY_PROGRESS: 'my-progress',
  REGISTER: 'register',
  DOCUMENTS: 'documents',
  EDUCATION: 'education',
  EVENTS: 'events',
  MISSIONS: 'missions',
  BADGES: 'badges',
  SPORT_HISTORY: 'sport-history',
  ACADEMIC_HISTORY: 'academic-history',
  PREFERENCES: 'preferences',
  ADDITIONAL_INFORMATION: 'additional-information',
  CONFIGURATION: 'configuration',
  PROFILE: 'profile',
  PLANS: 'plans',
  ABOUT_US: 'about-us',
  FEED: 'feed',
  OPPORTUNITY: 'opportunity',
  CP_ALUMNI: 'cp-alumni',
  PRIVACY_POLICY: 'privacy-policy',
  SCHOLARSHIP: 'scholarship',
  VACANCY: 'vacancy',
  UNIVERSITIES: 'universities',
  UNIVERSITIES_INFO: 'info-university',
  MATCH: 'match',
  MATCH_MODULE: 'module',
  MATCH_USER: 'myMatchs',
  MATCH_LIST: 'match-list',
  PHASE: 'phase',
  PHASE_INFO: 'phase-info',
  LESSON: 'lesson',
  MESSAGES: 'messages',
  STORE: 'store',
  PLAYER_PROFILE: 'player',
}

export const FULL_ROUTES = {
  SIGN_UP: [APP_ROUTES.AUTH, APP_ROUTES.SIGN_UP],
  CREATE_PASSWORD: [APP_ROUTES.AUTH, APP_ROUTES.CREATE_PASSWORD],
  COMPLETE_REGISTRATION: [APP_ROUTES.AUTH, APP_ROUTES.COMPLETE_REGISTRATION],
  VERIFY: [APP_ROUTES.AUTH, APP_ROUTES.VERIFY],
  VERIFY_EMAIL: [APP_ROUTES.AUTH, APP_ROUTES.VERIFY_EMAIL],
  FORGOT_PASSWORD: [APP_ROUTES.AUTH, APP_ROUTES.FORGOT_PASSWORD],
  HOME: [APP_ROUTES.MAIN, APP_ROUTES.HOME],
  MY_WAY: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY],
  MY_WAY_REGISTER: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.REGISTER],
  MY_WAY_REGISTER_SPORT_HISTORY: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.REGISTER, APP_ROUTES.SPORT_HISTORY],
  MY_WAY_REGISTER_ACADEMIC_HISTORY: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.REGISTER, APP_ROUTES.ACADEMIC_HISTORY],
  MY_WAY_REGISTER_PREFERENCES: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.REGISTER, APP_ROUTES.PREFERENCES],
  MY_WAY_REGISTER_ADDITIONAL_INFORMATION: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.REGISTER, APP_ROUTES.ADDITIONAL_INFORMATION],
  MY_WAY_DOCUMENTS: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.DOCUMENTS],
  MY_WAY_EDUCATION: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.EDUCATION],
  MY_WAY_EDUCATION_PHASE: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.EDUCATION, APP_ROUTES.PHASE],
  MY_WAY_EDUCATION_PHASE_INFO: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.EDUCATION, APP_ROUTES.PHASE_INFO],
  MY_WAY_EVENTS: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.EVENTS],
  MY_WAY_MY_PROGRESS: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.MY_PROGRESS],
  MY_WAY_MY_PROGRESS_MISSIONS: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.MY_PROGRESS, APP_ROUTES.MISSIONS],
  MY_WAY_MY_PROGRESS_BADGES: [APP_ROUTES.MAIN, APP_ROUTES.MY_WAY, APP_ROUTES.MY_PROGRESS, APP_ROUTES.BADGES],
  CONFIGURATION: [APP_ROUTES.MAIN, APP_ROUTES.CONFIGURATION],
  CONFIGURATION_PROFILE: [APP_ROUTES.MAIN, APP_ROUTES.CONFIGURATION, APP_ROUTES.PROFILE],
  CONFIGURATION_PLANS: [APP_ROUTES.MAIN, APP_ROUTES.CONFIGURATION, APP_ROUTES.PLANS],
  CONFIGURATION_ABOUT_US: [APP_ROUTES.MAIN, APP_ROUTES.CONFIGURATION, APP_ROUTES.ABOUT_US],
  CONFIGURATION_PRIVACY_POLICY: [APP_ROUTES.MAIN, APP_ROUTES.CONFIGURATION, APP_ROUTES.PRIVACY_POLICY],
  SCHOLARSHIP: [APP_ROUTES.MAIN, APP_ROUTES.SCHOLARSHIP],
  SCHOLARSHIP_VACANCY: [APP_ROUTES.MAIN, APP_ROUTES.SCHOLARSHIP, APP_ROUTES.VACANCY],
  UNIVERSITIES: [APP_ROUTES.MAIN, APP_ROUTES.UNIVERSITIES],
  UNIVERSITIES_INFO: [APP_ROUTES.MAIN, APP_ROUTES.UNIVERSITIES, APP_ROUTES.UNIVERSITIES_INFO],
  MATCH: [APP_ROUTES.MAIN, APP_ROUTES.MATCH],
  MATCH_MODULE: [APP_ROUTES.MAIN, APP_ROUTES.MATCH, APP_ROUTES.MATCH_MODULE],
  MATCH_USER: [APP_ROUTES.MAIN, APP_ROUTES.MATCH, APP_ROUTES.MATCH_USER],
  MATCH_LIST: [APP_ROUTES.MAIN, APP_ROUTES.MATCH, APP_ROUTES.MATCH_LIST],
  EDUCATION_LESSON: [APP_ROUTES.EDUCATION, APP_ROUTES.LESSON],
  MESSAGES: [APP_ROUTES.MAIN, APP_ROUTES.MESSAGES],
  STORE: [APP_ROUTES.MAIN, APP_ROUTES.STORE],
  PLAYER_PROFILE: [APP_ROUTES.MAIN, APP_ROUTES.PLAYER_PROFILE],
}

export const REDIRECT_DEFAULT = `/${APP_ROUTES.MAIN}/${APP_ROUTES.HOME}`;
